{
  "cookies": {
    "title": "Cookies",
    "manage": "Gérer mes cookies",
    "body": "Avec votre accord, nous utilisons des cookies {{purposes}}. Refuser ne change rien d'autre dans le portail, et vous pouvez changer d'avis à tout moment via « $t(cookies.manage) » en bas de chaque page. <privacy>Politique de confidentialité</privacy>",
    "short": {
      "measurement": "pour mesurer l'audience du portail et les inscriptions (Google Analytics)",
      "advertising": "pour nos publicités sur LinkedIn et Google"
    },
    "and": " et ",
    "customize": "Personnaliser mes choix",
    "purposes": {
      "measurement": {
        "title": "Mesure d'audience",
        "text": "Google Analytics compte les visites, les pages lues et les comptes créés."
      },
      "advertising": {
        "title": "Publicité LinkedIn et Google",
        "text": "LinkedIn et Google mesurent les résultats de nos publicités et les montrent sur leurs plateformes aux visiteurs du portail."
      }
    },
    "save": "Enregistrer mes choix",
    "accept": "Tout accepter",
    "refuse": "Tout refuser"
  },
  "app": {
    "title": "Compte Sculpt",
    "byline": "par Peerception",
    "loading": "Chargement…",
    "language": "Langue",
    "signOut": "Se déconnecter",
    "back": "Retour",
    "backToSite": "Retour sur sculpt-agent.ai",
    "save": "Enregistrer",
    "saving": "Enregistrement…",
    "saved": "Enregistré.",
    "cancel": "Annuler",
    "confirm": "Confirmer",
    "close": "Fermer",
    "yes": "Oui",
    "no": "Non",
    "error": "Une erreur est survenue. Réessayez.",
    "rateLimited": "Trop de tentatives. Patientez un instant puis réessayez.",
    "rateLimitedTitle": "Trop de tentatives",
    "notFound": "Cette page n'existe pas.",
    "goHome": "Aller à mon compte",
    "about": "À propos : {{label}}"
  },
  "nav": {
    "account": "Compte",
    "organization": "Organisation",
    "usage": "Consommation",
    "invoices": "Factures",
    "billing": "Abonnement"
  },
  "banner": {
    "unverified": "Confirmez votre adresse e-mail pour activer l'assistant dans Excel. Un lien a été envoyé à {{email}}.",
    "resend": "Renvoyer l'e-mail",
    "resent": "E-mail envoyé. Vérifiez votre boîte de réception (et les indésirables).",
    "suspended": "Votre organisation est suspendue. Contactez Peerception pour rétablir l'accès.",
    "archived": "Votre organisation est archivée. Contactez Peerception.",
    "goBilling": "Voir l'abonnement"
  },
  "auth": {
    "email": "E-mail",
    "emailPlaceholder": "vous@entreprise.com",
    "password": "Mot de passe",
    "passwordPlaceholder": "8 caractères minimum",
    "passwordRule": "8 caractères minimum.",
    "confirmPassword": "Confirmer le mot de passe",
    "show": "afficher",
    "hide": "masquer",
    "firstName": "Prénom",
    "lastName": "Nom",
    "microsoft": "Continuer avec Microsoft",
    "or": "ou",
    "signIn": "Se connecter",
    "signingIn": "Connexion…",
    "createAccount": "Créer un compte",
    "creating": "Création du compte…",
    "haveAccount": "Vous avez déjà un compte ?",
    "noAccount": "Nouveau sur Sculpt ?",
    "forgot": "Mot de passe oublié ?",
    "invalidCredentials": "E-mail ou mot de passe incorrect.",
    "accountDisabled": "Ce compte est désactivé. Contactez Peerception.",
    "passwordsDiffer": "Les deux mots de passe diffèrent.",
    "weakPassword": "Le mot de passe doit faire au moins 8 caractères.",
    "emailPlusAddress": "Utilisez votre adresse sans la partie « +… » : un compte s'ouvre sur la boîte mail elle-même.",
    "emailDisposableDomain": "Les adresses e-mail jetables ou temporaires ne peuvent pas ouvrir de compte. Utilisez votre propre adresse.",
    "emailTaken": "Un compte existe déjà avec cet e-mail. Connectez-vous.",
    "badInvitation": "Cette invitation n'est plus valable.",
    "invitationMismatch": "Cette invitation a été envoyée à une autre adresse.",
    "sso": {
      "sso_failed": "La connexion Microsoft a échoué. Réessayez.",
      "cancelled": "Connexion annulée.",
      "account_disabled": "Ce compte est désactivé. Contactez Peerception.",
      "staff_only": "Cette connexion est réservée à l'équipe Peerception.",
      "email_plus_address": "Utilisez votre adresse sans la partie « +… » : un compte s'ouvre sur la boîte mail elle-même.",
      "email_disposable_domain": "Les adresses e-mail jetables ou temporaires ne peuvent pas ouvrir de compte. Utilisez votre propre adresse.",
      "link_mismatch": "Ce compte Microsoft n'utilise pas l'adresse de votre compte Sculpt : rien n'a été lié. Connectez-vous à Microsoft avec cette adresse, puis réessayez."
    }
  },
  "signup": {
    "title": "Créez votre compte Sculpt",
    "subtitle": "L'assistant de modélisation financière dans Excel. Gratuit pour commencer.",
    "invited": "Vous rejoignez {{organization}}",
    "invitedHint": "L'invitation a été envoyée à cette adresse."
  },
  "legal": {
    "mention": "En continuant, vous acceptez les <terms>Conditions générales de vente</terms>, dont l'<dpa>Accord de traitement des données</dpa>. Voir notre <privacy>Politique de confidentialité</privacy>.",
    "accept": "J'accepte les <terms>Conditions générales de vente</terms>, dont l'<dpa>Accord de traitement des données</dpa>."
  },
  "login": {
    "title": "Connexion",
    "subtitle": "Utilisez votre compte Sculpt.",
    "rateLimited": "Trop de tentatives de connexion. Patientez 15 minutes, ou connectez-vous avec Microsoft."
  },
  "discovery": {
    "title": "Comment nous avez-vous connus ?",
    "subtitle": "Cette question est facultative. Votre réponse nous aide à savoir où faire connaître Sculpt.",
    "continue": "Continuer",
    "skip": "Passer",
    "sources": {
      "linkedin": "LinkedIn",
      "google": "Google",
      "youtube": "YouTube",
      "word_of_mouth": "Bouche à oreille",
      "other": "Autre"
    }
  },
  "verify": {
    "title": "Confirmation de votre e-mail…",
    "success": "Votre e-mail est confirmé.",
    "successHint": "Ouvrez Excel, installez le complément Sculpt et connectez-vous avec ce compte. Votre organisation : {{organization}}.",
    "openAccount": "Ouvrir mon compte",
    "failed": "Ce lien est invalide ou a expiré.",
    "failedHint": "Les liens de confirmation durent 24 heures. Connectez-vous et demandez-en un nouveau.",
    "resend": "Envoyer un nouveau lien",
    "signIn": "Se connecter"
  },
  "forgot": {
    "title": "Réinitialiser votre mot de passe",
    "subtitle": "Indiquez votre e-mail ; si un compte existe, un lien arrive.",
    "send": "Envoyer le lien",
    "sending": "Envoi…",
    "done": "Si un compte existe pour {{email}}, un lien de réinitialisation arrive. Il dure une heure.",
    "backToLogin": "Retour à la connexion"
  },
  "reset": {
    "title": "Choisissez un nouveau mot de passe",
    "subtitle": "Cela vous déconnecte partout ailleurs.",
    "submit": "Définir le mot de passe",
    "submitting": "Enregistrement…",
    "done": "Votre mot de passe est défini. Vous avez été déconnecté partout ; connectez-vous avec le nouveau.",
    "failed": "Ce lien est invalide ou a expiré. Demandez-en un nouveau.",
    "again": "Demander un nouveau lien"
  },
  "invite": {
    "title": "Vous êtes invité",
    "lead": "{{inviter}} vous invite à rejoindre {{organization}} sur Sculpt en tant que {{role}}.",
    "leadNoInviter": "Vous êtes invité à rejoindre {{organization}} sur Sculpt en tant que {{role}}.",
    "sentTo": "Envoyée à {{email}}.",
    "createAccount": "Créer un compte",
    "signInToAccept": "Se connecter pour accepter",
    "accept": "Rejoindre {{organization}}",
    "accepting": "Rattachement…",
    "accepted": "Vous êtes maintenant membre de {{organization}}.",
    "mismatch": "Vous êtes connecté en tant que {{current}}, mais cette invitation a été envoyée à {{email}}. Déconnectez-vous et utilisez cette adresse.",
    "invalid": "Cette invitation n'est plus valable.",
    "invalidHint": "Elle a peut-être été acceptée, révoquée, ou a expiré après 14 jours. Demandez-en une nouvelle à l'administrateur de l'organisation.",
    "ownerMustTransfer": "Vous possédez une organisation avec d'autres membres : transférez sa propriété avant d'en rejoindre une autre.",
    "alreadyMember": "Vous êtes déjà membre de cette organisation."
  },
  "callback": {
    "title": "Connexion en cours…",
    "failed": "La connexion n'a pas abouti.",
    "retry": "Retour à la connexion",
    "backToAccount": "Retour à mon compte"
  },
  "role": {
    "owner": "Propriétaire",
    "admin": "Admin",
    "member": "Membre"
  },
  "account": {
    "title": "Votre compte",
    "profile": "Profil",
    "locale": "Langue des e-mails",
    "password": "Mot de passe",
    "currentPassword": "Mot de passe actuel",
    "newPassword": "Nouveau mot de passe",
    "changePassword": "Changer le mot de passe",
    "passwordChanged": "Mot de passe changé.",
    "wrongPassword": "Le mot de passe actuel est incorrect.",
    "setPassword": "Ce compte se connecte avec Microsoft et n'a pas de mot de passe.",
    "setPasswordLink": "Définir un mot de passe par e-mail",
    "microsoft": "Connexion Microsoft",
    "microsoftLinked": "Lié à {{email}}",
    "microsoftTenant": "Tenant {{tenant}}",
    "microsoftNotLinked": "Non lié. Liez le compte Microsoft qui utilise {{email}} pour vous connecter en un clic depuis Excel.",
    "linkMicrosoft": "Lier Microsoft",
    "excel": {
      "title": "Démarrer dans Excel",
      "step1": "Installez le complément Sculpt dans Excel Desktop (Windows ou Mac).",
      "step2": "Ouvrez le volet Sculpt et connectez-vous avec ce compte.",
      "step3": "Interrogez l'assistant sur le classeur ouvert.",
      "link": "Guide d'installation"
    },
    "review": {
      "title": "Relecture de vos conversations",
      "intro": "Pour contrôler la qualité de Sculpt, nous relisons une partie des conversations, choisie au hasard. Vous pouvez vous y opposer en écrivant à",
      "objected": "Votre opposition est enregistrée depuis le {{date}} : vos conversations ne sont plus tirées au sort.",
      "organization": "Votre organisation est exclue de cette relecture depuis le {{date}}.",
      "guardrail": "Les conversations où Sculpt a échoué, ou que vous nous signalez ou notez négativement, restent relues pour résoudre les incidents."
    }
  },
  "org": {
    "title": "Organisation",
    "personalHint": "Ceci est votre organisation personnelle. Invitez un collègue ou revendiquez le domaine de votre entreprise pour en faire une équipe.",
    "name": "Nom",
    "plan": "Offre",
    "billingEmail": "E-mail de facturation",
    "readOnly": "Seuls les admins peuvent modifier ces informations.",
    "members": "Membres",
    "member": "membre",
    "membersCount": "{{count}} membre",
    "membersCount_other": "{{count}} membres",
    "joined": "Arrivé le",
    "unverified": "non vérifié",
    "inactive": "inactif",
    "you": "vous",
    "makeAdmin": "Passer admin",
    "makeMember": "Passer membre",
    "remove": "Retirer",
    "removeConfirm": "Retirer {{email}} de l'organisation ? La personne garde son compte dans une organisation personnelle.",
    "transfer": "Transférer la propriété",
    "transferConfirm": "Faire de {{email}} le propriétaire ? Vous devenez admin.",
    "invitations": "Invitations",
    "invitationsNone": "Aucune invitation en attente.",
    "invite": "Inviter",
    "inviting": "Invitation…",
    "invited": "Invitation envoyée à {{email}}.",
    "inviteEmail": "E-mail à inviter",
    "inviteRole": "Rôle",
    "expires": "Expire le",
    "revoke": "Révoquer",
    "alreadyMember": "Cette adresse est déjà membre.",
    "claims": "Domaines et tenants Microsoft",
    "claimsHint": "Les personnes qui s'inscrivent avec un e-mail vérifié d'un domaine revendiqué, ou avec un compte Microsoft professionnel d'un tenant revendiqué, rejoignent automatiquement cette organisation.",
    "claimsRules": "Peerception vérifie chaque revendication avant que quiconque ne rejoigne l'organisation par elle ; vous la verrez passer de « en attente » à « vérifiée ». Les domaines de messagerie publics (gmail.com, outlook.com…) ne peuvent pas être revendiqués.",
    "claimsNone": "Aucune revendication pour l'instant.",
    "claimKind": "Type",
    "claimDomain": "Domaine e-mail",
    "claimTenant": "Identifiant de tenant Microsoft",
    "claimValue": "Valeur",
    "claimDomainPlaceholder": "entreprise.com",
    "claimTenantPlaceholder": "00000000-0000-0000-0000-000000000000",
    "claim": "Revendiquer",
    "claiming": "Revendication…",
    "verified": "Vérifié",
    "pending": "En attente de vérification par Peerception",
    "autoJoin": "Rattachement automatique",
    "claimTaken": "Une autre organisation détient cette revendication.",
    "claimRefused": "Cette valeur ne peut pas être revendiquée (domaine de messagerie public, ou domaine / identifiant de tenant invalide).",
    "leave": "Quitter l'organisation",
    "leaveHint": "Vous obtenez une nouvelle organisation personnelle. Vos conversations restent les vôtres.",
    "leaveConfirm": "Quitter {{organization}} ?",
    "ownerMustTransfer": "Vous possédez cette organisation et elle a d'autres membres : transférez d'abord la propriété.",
    "left": "Vous avez quitté l'organisation.",
    "seeBilling": "Voir l'abonnement",
    "cap": "Limite par mois",
    "capTrial": "Limite pour l'essai",
    "noCap": "Sans limite",
    "capDefault": "{{amount}} (par défaut)",
    "capUseDefault": "Limite par défaut ({{amount}})",
    "capUseDefaultNone": "Limite par défaut (aucune : sans limite)",
    "capOwn": "Limite propre",
    "capAmount": "Limite propre en {{symbol}}",
    "capNone": "Sans limite",
    "capInvalid": "Saisissez un montant en {{currency}}, par exemple 50.",
    "defaultCap": "Limite mensuelle par défaut par membre",
    "defaultCapTrial": "Limite par défaut par membre pour l'essai",
    "defaultCapCurrent": "Limite par défaut actuelle : {{amount}} par mois.",
    "defaultCapCurrentTrial": "Limite par défaut actuelle : {{amount}} pour l'essai.",
    "defaultCapNone": "Pas encore de limite par défaut : les membres sans limite propre n'ont pas de limite.",
    "defaultCapHint": "Elle s'applique à chaque membre sans limite propre. Un membre peut avoir sa propre limite, ou aucune, dans le tableau des membres ci-dessous.",
    "defaultCapLabel": "Limite par membre ({{symbol}})",
    "defaultCapSuggested_one": "Suggestion : {{amount}} (crédits mensuels {{pool}} ÷ {{count}} place)",
    "defaultCapSuggested_other": "Suggestion : {{amount}} (crédits mensuels {{pool}} ÷ {{count}} places)",
    "defaultCapSuggestedTrial_one": "Suggestion : {{amount}} (crédits de l'essai {{pool}} ÷ {{count}} place)",
    "defaultCapSuggestedTrial_other": "Suggestion : {{amount}} (crédits de l'essai {{pool}} ÷ {{count}} places)",
    "defaultCapSuggestedPlain": "Suggestion : {{amount}}",
    "defaultCapRemove": "Supprimer la limite par défaut",
    "seatsFull": "Toutes les places sont prises ({{seats}}, invitations en attente comprises). Ajoutez d'abord des places depuis l'abonnement.",
    "seatsFullScheduled": "Le changement d'offre programmé en fin de période laisse moins de places : vous ne pouvez pas inviter au-delà. Annulez-le depuis l'abonnement pour inviter.",
    "seatsLine": "{{used}} places sur {{seats}} utilisées",
    "addSeats": "ajouter des places",
    "billingEmailHint": "Où nous envoyons commandes et factures. Vide : l'e-mail du propriétaire."
  },
  "usage": {
    "title": "Consommation",
    "allowance": "Enveloppe",
    "unlimited": "Illimitée",
    "spent": "{{spent}} sur {{allowance}} utilisés",
    "spentUnlimited": "{{spent}} utilisés",
    "remaining": "{{remaining}} restants",
    "periodTotal": "au total",
    "periodMonth": "ce mois-ci",
    "since": "depuis le {{date}}",
    "limitReached": "L'enveloppe est épuisée : l'assistant ne répond plus tant qu'elle n'est pas étendue. Contactez Peerception.",
    "requests": "{{count}} appel au modèle",
    "requests_other": "{{count}} appels au modèle",
    "perMember": "Par membre",
    "yourLine": "Votre consommation",
    "noUsage": "Aucune consommation sur cette période.",
    "hint": "Chaque appel au modèle est facturé en {{currency}} ; les crédits mensuels appartiennent à votre organisation, partagés entre ses membres, puis les crédits des packs prennent le relais.",
    "reason": {
      "no_subscription": "Votre organisation n'a pas d'abonnement actif : l'assistant est en pause.",
      "trial_ended": "L'essai est terminé : l'assistant est en pause jusqu'au choix d'une offre.",
      "payment_overdue": "Un renouvellement est impayé : l'assistant est en pause jusqu'au paiement.",
      "member_cap_reached": "Vous avez atteint la limite fixée par votre administrateur ({{cap}}).",
      "user_cap_reached": "Vous avez consommé votre part des crédits mensuels pour cette période ({{cap}}). Un pack de crédits ou un palier supérieur la lève.",
      "limit_reached": "Les crédits mensuels et les crédits des packs sont épuisés : l'assistant est en pause jusqu'à la prochaine période, ou jusqu'à l'ajout de crédits.",
      "free_full": "Toutes les places de l'offre Free sont prises pour le moment : choisissez une offre pour utiliser l'assistant."
    },
    "goBilling": "Ouvrir l'abonnement",
    "yours": "Votre usage",
    "capPerMonth": "par mois",
    "capForTrial": "pour l'essai",
    "userCap": "Votre part (par membre)",
    "credits": "Crédits restants",
    "noPool": "Aucun abonnement : pas de crédits mensuels. Les crédits des packs restants sont utilisés.",
    "poolTitle": "Crédits mensuels de l'abonnement",
    "poolTitleOffer": "Crédits mensuels de l'abonnement · {{offer}}",
    "creditsTitle": "Crédits des packs",
    "creditsLeft": "{{credits}} disponibles",
    "creditsHint": "Les packs ne se renouvellent pas chaque mois : ils prennent le relais une fois les crédits mensuels épuisés, ceux qui expirent le plus tôt en premier.",
    "periodTrial": "essai",
    "until": "jusqu'au {{date}}",
    "own": {
      "title": "Votre consommation",
      "bar": "Votre limite utilisée sur la période",
      "noLimit": "Aucune limite fixée par votre administrateur",
      "limitMonth": "Votre limite : {{cap}} par mois",
      "limitTrial": "Votre limite : {{cap}} pour l'essai",
      "orgSpent": "La consommation de votre organisation pour cette période est épuisée : l'assistant est en pause jusqu'à la prochaine période ou jusqu'à ce qu'un administrateur ajoute des crédits.",
      "hint": "Chaque appel au modèle est facturé en {{currency}}. Les administrateurs de votre organisation gèrent l'abonnement et les limites."
    }
  },
  "invoices": {
    "title": "Factures",
    "none": "Aucune facture pour l'instant.",
    "number": "Numéro",
    "issued": "Émise le",
    "due": "Échéance",
    "amount": "Montant HT",
    "status": "Statut",
    "download": "Télécharger le PDF",
    "adminOnly": "Seuls les admins de l'organisation peuvent voir ses factures.",
    "statusLabel": {
      "sent": "À régler",
      "paid": "Payée",
      "void": "Annulée",
      "draft": "Brouillon"
    },
    "total": "Total TTC",
    "kind": {
      "invoice": "Facture",
      "credit_note": "Avoir"
    },
    "creditsInvoice": "Annule la facture {{number}}",
    "creditNote": "Avoir"
  },
  "handoff": {
    "notice": "Vous vous connectez pour le complément Sculpt dans Excel. Cette fenêtre se fermera d’elle-même une fois terminé."
  },
  "pricing": {
    "currency": "Devise",
    "trialFor": "Gratuit pendant {{days}} jours",
    "perSeat": "{{price}} par utilisateur / mois",
    "unlimitedUsage": "Crédits illimités",
    "trialUsage": "{{amount}} de crédits pour l'essai",
    "usagePerSeat": "{{amount}} de crédits par utilisateur / mois",
    "userCap": "Jusqu'à {{amount}} par membre / mois",
    "seatsFrom": "À partir de {{min}} utilisateur(s)",
    "seatsRange": "De {{min}} à {{max}} utilisateurs",
    "validFor": "valable {{count}} mois",
    "validFor_other": "valable {{count}} mois",
    "noExpiry": "sans expiration",
    "fromTier": "À partir de {{price}} / mois",
    "tierRange": "De {{min}} à {{max}} de crédits par mois",
    "usagePerMonth": "{{amount}} de crédits par mois",
    "oneUser": "1 utilisateur",
    "anyUsers": "Autant d'utilisateurs que nécessaire",
    "tierLabel": "Crédits mensuels",
    "tierUsage": "{{usage}} de crédits",
    "lowUsage": "Cela fait {{perUser}} de crédits par utilisateur et par mois : sous {{min}}, les membres risquent d'être bloqués tôt dans le mois.",
    "features": {
      "free": [
        "Sans carte bancaire",
        "Passez à une offre payante quand vous voulez"
      ],
      "solo": [
        "Pour un modélisateur",
        "Crédits bonus sur les paliers supérieurs",
        "Packs de crédits si besoin"
      ],
      "team": [
        "Crédits partagés par l'équipe",
        "Plafonds par membre fixés par un admin",
        "Consommation de crédits par membre",
        "Rôles : propriétaire, admin, membre",
        "Une seule facture pour l'équipe"
      ]
    },
    "plusSharedCredits": "+ crédits mensuels partagés à partir de {{price}}",
    "plusCredits": "+ crédits mensuels à partir de {{price}}",
    "tierRangeShared": "De {{min}} à {{max}} de crédits par mois, partagés par toute l'équipe",
    "breakdown": {
      "seats": "Utilisateurs",
      "credits": "Crédits mensuels",
      "sharedCredits": "Crédits partagés",
      "usage": "({{usage}} d'usage)",
      "usageTeam": "({{usage}} d'usage pour toute l'équipe)",
      "total": "Total / mois HT",
      "totalInclVat": "Total / mois TTC",
      "perUser": "≈ {{perUser}} d'usage par utilisateur"
    }
  },
  "billing": {
    "title": "Abonnement",
    "none": "Aucun abonnement",
    "noneHint": "Votre organisation n'a pas d'abonnement. Choisissez une offre ci-dessous.",
    "adminsOnly": "Seuls le propriétaire et les administrateurs de l'organisation peuvent modifier l'abonnement ou acheter des crédits.",
    "status": {
      "trialing": "essai",
      "active": "actif",
      "past_due": "impayé",
      "ended": "terminé",
      "canceled": "résilié"
    },
    "reason": {
      "packs_only": "Votre organisation n'a plus d'abonnement : l'assistant utilise les crédits des packs restants, puis se met en pause. Choisissez une offre pour retrouver des crédits mensuels et acheter des packs.",
      "no_subscription": "Votre organisation n'a pas d'abonnement actif : l'assistant est en pause.",
      "trial_ended": "L'essai est terminé : choisissez une offre pour réactiver l'assistant.",
      "payment_overdue": "Un renouvellement est impayé : l'assistant est en pause jusqu'au paiement.",
      "free_full": "Toutes les places de l'offre Free sont prises pour le moment. Choisissez Solo ou Team ci-dessous pour utiliser l'assistant."
    },
    "poolLabel": "Crédits mensuels sur la période",
    "poolUnlimited": "{{spent}} utilisés · illimité",
    "poolUsed": "{{spent}} sur {{pool}}",
    "prorated": "Au prorata : l'offre a changé le {{date}}, en cours de période, donc les crédits du nouveau palier ne comptent que pour les jours restants.",
    "proratedNext": "{{full}} par mois à partir du {{date}}.",
    "offer": "Offre",
    "version": "conditions de la version {{version}}",
    "price": "Prix",
    "free": "Gratuit",
    "priceTotal": "{{price}} × {{seats}} = {{total}} / mois HT",
    "seats": "Utilisateurs",
    "seatsUsed": "{{used}} sur {{seats}} (membres et invitations en attente)",
    "trialEnds": "Fin de l'essai",
    "endsOn": "Se termine le",
    "renewsOn": "Renouvellement le",
    "userCap": "Plafond par membre / mois",
    "credits": "Crédits des packs",
    "grandfathered": "Vous conservez les conditions de votre souscription ; les conditions actuelles de l'offre diffèrent et s'appliquent si vous changez d'offre.",
    "scheduled": "Prévu le {{date}} : {{offer}} × {{seats}} à {{price}} par utilisateur.",
    "undo": "Annuler",
    "canceling": "L'abonnement se termine le {{date}}.",
    "keep": "Conserver l'abonnement",
    "pendingTitle": "La commande n° {{number}} attend son paiement : {{amount}} HT",
    "pendingHint": "Elle prend effet dès réception du paiement.",
    "pendingRenewal": "Le renouvellement de l'abonnement ; l'assistant reste actif pendant le délai de grâce.",
    "withdraw": "Retirer cette commande",
    "withdrawConfirm": "Retirer cette commande ? Rien ne changera.",
    "chooseTitle": "Choisir une offre",
    "changeTitle": "Changer d'offre ou d'utilisateurs",
    "current": "actuelle",
    "error": {
      "seats_below_members": "Moins d'utilisateurs que vos membres et invitations en attente : retirez-en d'abord.",
      "seats_out_of_range": "Cette offre ne permet pas ce nombre d'utilisateurs.",
      "no_change": "C'est déjà votre abonnement.",
      "trial_not_selectable": "L'essai ne peut pas être choisi à nouveau.",
      "offer_not_found": "Cette offre n'est plus disponible.",
      "pack_not_found": "Ce pack n'est plus disponible.",
      "renewal_is_owed": "Un renouvellement ne peut pas être retiré.",
      "free_not_selectable": "Free ne peut pas être choisi.",
      "tier_required": "Choisissez vos crédits mensuels.",
      "tier_not_offered": "Ce palier de crédits n'est pas proposé.",
      "packs_require_paid_offer": "Les packs de crédits s'ajoutent à Solo ou Team.",
      "currency_mismatch": "Votre organisation est désormais facturée dans une autre devise : rechargez la page pour voir ses prix.",
      "currency_locked": "La devise de votre organisation est fixée par ce qu'elle a déjà payé.",
      "currency_not_offered": "Les prix ne sont pas proposés dans cette devise."
    },
    "creditsTitle": "Crédits des packs",
    "creditsHint": "Les crédits des packs sont utilisés une fois les crédits mensuels de la période épuisés, ceux qui expirent le plus tôt en premier.",
    "grantPack": "Pack",
    "grantStaff": "Offert par Peerception",
    "expiresOn": "jusqu'au {{date}}",
    "buy": "Acheter",
    "ordersTitle": "Commandes",
    "orderWhat": "Objet",
    "orderDate": "Date",
    "kind": {
      "subscribe": "Abonnement",
      "change": "Changement d'offre",
      "seats": "Utilisateurs",
      "renewal": "Renouvellement",
      "pack": "Crédits"
    },
    "orderStatus": {
      "pending": "en attente de paiement",
      "paid": "payée",
      "canceled": "retirée",
      "failed": "échouée"
    },
    "invoicesHint": "Les factures sont envoyées par e-mail et listées dans",
    "cancelTitle": "Résilier l'abonnement",
    "cancelHint": "L'abonnement court jusqu'au {{date}}, puis l'assistant est mis en pause. Vous pouvez annuler d'ici là.",
    "cancel": "Résilier en fin de période",
    "cancelConfirm": "Résilier l'abonnement au {{date}} ?",
    "tier": "Crédits mensuels",
    "tierValue": "{{usage}} / mois",
    "priceSum": "{{total}} / mois HT = {{parts}}",
    "pricePartTier": "{{price}} d'abonnement",
    "pricePartSeats": "{{price}} × {{count}} utilisateur",
    "pricePartSeats_other": "{{price}} × {{count}} utilisateurs",
    "priceMonthly": "{{total}} / mois HT",
    "scheduledTier": "Prévu le {{date}} : {{offer}} × {{seats}} avec le palier {{tier}}.",
    "packsNeedPaid": "Les packs de crédits s'ajoutent à Solo ou Team.",
    "amountExclVat": "HT",
    "amountInclVat": "TTC",
    "vat": {
      "line": "TVA {{rate}} : {{amount}}",
      "reverseCharge": "Autoliquidation : TVA due par le client",
      "outsideScope": "TVA non applicable",
      "total": "Total TTC : {{total}}",
      "held": "Votre numéro de TVA est en cours de vérification : cette commande pourra être réglée dès qu'il sera confirmé.",
      "heldShort": "en vérification",
      "noProfile": "La TVA est calculée dès que le profil de facturation est complet.",
      "noProfileLink": "Compléter le profil de facturation"
    },
    "card": {
      "pay": "Payer {{total}} par carte",
      "redirecting": "Ouverture de la page de paiement…",
      "saved": "Carte enregistrée",
      "savedValue": "{{label}}, expire {{expiry}}",
      "retry": "Réessayer",
      "return": {
        "checking": "Vérification de votre paiement…",
        "paid": "Paiement reçu, votre commande est active.",
        "failed": "Le paiement a été refusé. Rien n'a été débité.",
        "canceled": "Le paiement a été annulé. Rien n'a été débité.",
        "expired": "La page de paiement a expiré avant le paiement. Rien n'a été débité.",
        "waiting": "Nous attendons la confirmation de votre banque ; vous recevrez un e-mail dès qu'elle arrive."
      },
      "error": {
        "payments_disabled": "Le paiement par carte n'est pas encore disponible.",
        "order_not_payable": "Cette commande ne peut plus être réglée.",
        "vat_review_pending": "Votre numéro de TVA est en cours de vérification : cette commande pourra être réglée une fois confirmé.",
        "billing_profile_required": "Complétez le profil de facturation pour payer par carte.",
        "nothing_to_pay": "Il n'y a rien à régler pour cette commande.",
        "payment_provider_unavailable": "Le paiement par carte est momentanément indisponible, réessayez dans quelques minutes.",
        "payment_in_progress": "Un paiement par carte est en cours pour cette commande : elle ne peut pas être retirée maintenant."
      },
      "renewalsAuto": "Vos renouvellements sont débités automatiquement sur cette carte.",
      "none": "Aucune carte enregistrée — vos renouvellements seront à régler depuis cette page.",
      "register": "Enregistrer une carte",
      "change": "Changer de carte",
      "remove": "Supprimer la carte",
      "removeConfirm": "Supprimer la carte enregistrée ? Vos renouvellements devront alors être réglés à la main depuis cette page.",
      "verificationHint": "Enregistrer une carte passe par une vérification d'un montant nul sur la page de Mollie : rien n'est débité.",
      "expiresBeforeRenewal": "Cette carte expire avant votre prochain renouvellement : enregistrez-en une nouvelle pour qu'il passe sans interruption.",
      "autoFailed": "Le paiement automatique de votre renouvellement a échoué.",
      "update": {
        "checking": "Vérification de votre carte…",
        "paid": "Nouvelle carte enregistrée : vos prochains renouvellements seront débités dessus.",
        "failed": "La vérification de la carte a été refusée. Aucune carte n'a été enregistrée.",
        "canceled": "La vérification de la carte a été annulée. Aucune carte n'a été enregistrée.",
        "expired": "La page de vérification a expiré. Aucune carte n'a été enregistrée."
      }
    },
    "changeOffer": "Changer d'offre",
    "chooseOffer": "Souscrire"
  },
  "profile": {
    "title": "Profil de facturation",
    "hint": "Sculpt est vendu aux professionnels. Ces informations figurent sur vos factures, et votre pays et votre numéro de TVA déterminent la TVA de vos commandes.",
    "complete": "complet",
    "incompleteBadge": "incomplet",
    "incomplete": "Votre profil de facturation est incomplet : il est nécessaire pour calculer la TVA de vos commandes et émettre vos factures.",
    "kind": "Vous êtes",
    "kinds": {
      "company": "Une société",
      "individual": "Un entrepreneur individuel"
    },
    "nameCompany": "Raison sociale",
    "nameIndividual": "Nom et prénom",
    "street": "Adresse",
    "zip": "Code postal",
    "city": "Ville",
    "country": "Pays",
    "siren": "SIREN",
    "sirenHint": "9 chiffres. Vous pouvez coller votre SIRET : nous gardons le SIREN.",
    "vat": "Numéro de TVA intracommunautaire",
    "vatHint": "Facultatif. Vérifié auprès de VIES, le registre européen des numéros de TVA.",
    "vatValid": "Numéro de TVA {{number}} vérifié auprès de VIES le {{date}}.",
    "vatInvalid": "VIES ne reconnaît pas le numéro de TVA {{number}} : la TVA française (20 %) s'applique à vos commandes tant qu'il n'est pas valide.",
    "vatReview": "VIES n'a pas pu vérifier le numéro de TVA {{number}} pour l'instant. Nous le vérifions.",
    "vatReviewHeld": "En attendant, vos commandes ne peuvent pas être réglées.",
    "error": {
      "sirenRequired": "Indiquez le SIREN à 9 chiffres de votre entreprise.",
      "invalid_country": "Choisissez un pays dans la liste.",
      "invalid_customer_kind": "Choisissez société ou entrepreneur individuel.",
      "invalid_siren": "Un SIREN compte 9 chiffres.",
      "invalid_vat_number": "Ce n'est pas un numéro de TVA : il commence par le code du pays, par exemple DE123456789.",
      "vat_country_mismatch": "Ce numéro de TVA n'est pas celui du pays de facturation : un numéro de TVA européen commence par le code du pays.",
      "vat_number_required": "Indiquez votre numéro de TVA intracommunautaire : il est obligatoire pour une entreprise de l'Union européenne hors de France.",
      "vat_number_invalid": "VIES ne reconnaît pas ce numéro de TVA. Corrigez-le pour continuer.",
      "vies_unavailable": "VIES indisponible, réessayez dans quelques minutes.",
      "rate_limited": "Trop de vérifications d'affilée. Réessayez dans une minute."
    },
    "vatHintRequired": "Obligatoire pour une entreprise de l'Union européenne hors de France. Vérifié auprès de VIES.",
    "vatChecking": "Vérification auprès de VIES…",
    "vatRecognized": "Reconnu par VIES : {{name}}",
    "vatRecognizedNoName": "Numéro reconnu par VIES.",
    "vatRejected": "Numéro non reconnu par VIES. Corrigez-le pour continuer.",
    "vatUnavailableFr": "VIES ne répond pas pour l'instant : vous pouvez continuer, nous vérifierons le numéro plus tard.",
    "vatUnavailableEu": "VIES indisponible, réessayez dans quelques minutes.",
    "vatRetry": "Réessayer",
    "vatRequired": "Indiquez votre numéro de TVA intracommunautaire : il est obligatoire pour une entreprise de l'Union européenne hors de France.",
    "vatCheckFailed": "Le numéro n'a pas pu être vérifié. Réessayez.",
    "sirenInfo": "Les 9 chiffres qui identifient votre entreprise en France. Vous les trouvez sur votre extrait Kbis, votre avis de situation INSEE ou au début de votre SIRET. Ils sont obligatoires sur les factures électroniques.",
    "registration": "Numéro d'immatriculation",
    "registrationHint": "Facultatif. Il figure sur vos factures s'il est renseigné.",
    "registrationInfo": "Le numéro sous lequel votre entreprise est enregistrée dans son pays : Handelsregister (HRB) en Allemagne, numéro BCE en Belgique, KvK aux Pays-Bas, Companies House au Royaume-Uni… Saisissez-le tel qu'il doit apparaître sur vos factures."
  },
  "checkout": {
    "steps": "Étapes de la commande",
    "stepOffer": "Offre",
    "stepBilling": "Facturation",
    "stepPayment": "Paiement",
    "adminsOnly": "Seuls le propriétaire et les administrateurs de l'organisation peuvent changer d'offre ou acheter des crédits. Demandez à l'un d'eux.",
    "tabOffer": "Offre",
    "tabCredits": "Crédits",
    "yourOffer": "Votre offre",
    "perUser": "{{price}} par utilisateur/mois",
    "perMonth": "{{price}}/mois",
    "bonus": "+{{bonus}} % de crédits",
    "fewerUsers": "Un utilisateur de moins",
    "moreUsers": "Un utilisateur de plus",
    "atLeast": "au moins {{count}} (vos membres et invitations)",
    "noChange": "C'est votre offre actuelle.",
    "continue": "Continuer",
    "edit": "Modifier",
    "profileWhy": "Vos factures sont établies à ce nom. La TVA en dépend.",
    "vatReview": "Votre numéro de TVA est en cours de vérification. Vous pouvez passer la commande maintenant : vous pourrez la payer dès qu'il sera confirmé (nous vous écrivons).",
    "profileMissing": "Le profil de facturation manque.",
    "paymentTitle": "Paiement",
    "confirmTitle": "Confirmation",
    "scheduledHint": "Le changement s'applique le {{date}}. Rien à payer aujourd'hui.",
    "freeHint": "Rien à payer aujourd'hui.",
    "exclVat": "Montant HT",
    "inclVat": "Total TTC",
    "vatLine": "TVA {{rate}}",
    "secure": "Paiement sécurisé par Mollie (3-D Secure). Votre carte est enregistrée pour régler automatiquement vos renouvellements ; vous pouvez la changer ou la supprimer à tout moment.",
    "secureShort": "Paiement sécurisé",
    "leave": "Retour à la facturation",
    "transferHint": "Votre commande se règle par virement : les coordonnées accompagnent la commande.",
    "pay": "Payer {{total}} par carte",
    "payPack": "Commander et payer par carte",
    "placeOrder": "Passer la commande",
    "confirmChange": "Confirmer le changement",
    "summary": "Récapitulatif",
    "currently": "Actuellement : {{offer}}, {{price}}/mois",
    "today": "À payer aujourd'hui",
    "exclVatShort": "HT",
    "inclVatShort": "TTC",
    "prorata": "au prorata jusqu'au {{date}}",
    "appliesOn": "s'applique le {{date}}, rien à payer aujourd'hui",
    "then": "puis {{price}}/mois HT",
    "doneApplied": "C'est fait : votre nouvelle offre s'applique dès maintenant.",
    "doneScheduled": "C'est fait : le changement s'applique le {{date}}.",
    "doneOrdered": "Commande n° {{number}} passée : {{total}}.",
    "backToBilling": "Retour à la facturation",
    "payOrder": "Payer cette commande",
    "thenInclVat": "puis {{price}}/mois TTC",
    "vatLater": "TVA ajoutée à l'étape suivante",
    "billedTo": "Facturé à",
    "vatNumber": "TVA",
    "tierLabelShared": "Crédits partagés par l'équipe",
    "seatsOnTop": "Une seule réserve pour toute l'équipe. Les utilisateurs sont facturés en plus : {{price}} par utilisateur / mois."
  },
  "plan": {
    "trial": "Essai",
    "renews": "Renouvellement le {{date}}",
    "trialEnds": "Fin de l'essai le {{date}}",
    "details": "Détails",
    "upgrade": "Passer à l'offre supérieure",
    "bar": "Enveloppe utilisée sur la période",
    "credits": "+ {{credits}} de crédits prépayés"
  },
  "link": {
    "failed": "Ce lien a expiré",
    "expired": "Le lien ouvert depuis Excel ne sert qu'une fois, pendant deux minutes. Connectez-vous pour continuer.",
    "signIn": "Se connecter"
  },
  "models": {
    "title": "Modèles d'IA",
    "intro": "Les propriétaires et les admins choisissent les modèles que les membres de l'organisation peuvent utiliser. Un modèle refusé n'est jamais appelé pour l'organisation : ni pour les conversations, ni pour l'indexation des classeurs, ni pour les résumés.",
    "readOnly": "Seuls les admins peuvent modifier les modèles autorisés.",
    "madeBy": "modèle de {{maker}}",
    "hostedBy": "hébergé par {{host}}",
    "dataIn": "données traitées en",
    "price1": "Prix bas",
    "price2": "Prix élevé",
    "lastAllowed": "Au moins un modèle doit rester autorisé.",
    "noModelLeft": "Au moins un modèle doit rester autorisé."
  },
  "reviewSample": {
    "title": "Relecture qualité",
    "intro": "Pour contrôler la qualité de Sculpt, nous relisons une partie des conversations, choisie au hasard. Vous pouvez en exclure votre organisation : nous relisons alors seulement les conversations où Sculpt a échoué, celles que vos membres nous signalent ou notent négativement, et celles qui contreviennent à nos conditions.",
    "optOut": "Exclure l'organisation de la relecture des conversations tirées au hasard",
    "since": "Exclue depuis le {{date}}.",
    "ownerOnly": "Seul le propriétaire peut modifier ce choix.",
    "freeOffer": "Disponible sur les offres payantes."
  },
  "flag": {
    "US": "États-Unis",
    "FR": "France",
    "EU": "Union européenne"
  }
}
